// extracted by mini-css-extract-plugin
export var addButton = "_c8-0";
export var border = "_c8-8";
export var check = "_c8-h";
export var danger = "_c8-6";
export var dropdownContainer = "_c8-1";
export var editModalBody = "_c8-j";
export var footerContainer = "_c8-i";
export var fullWidth = "_c8-a";
export var hide = "_c8-9";
export var icon = "_c8-3";
export var input = "_c8-7";
export var inputFlex = "_c8-b";
export var inputWrapper = "_c8-c";
export var manualFocus = "_c8-5";
export var optionButton = "_c8-4";
export var pillWrapper = "_c8-e";
export var pointer = "_c8-2";
export var showOverflow = "_c8-f";
export var tagsFlex = "_c8-d";
export var xButton = "_c8-g";